import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { getPaymentSource } from 'services/reports-service';
import { getOptionsList } from 'services/types';
import { Multiselect, Select } from './fields';
import { MultiInput } from './multi-input';

export const AppFilter = (props) => {
  const { name = 'payment_terminal', multiple, ...rest } = props;
  const { t } = useTranslation();
  const title = t('grid.№ устройства');
  const [items, setItems] = useState(null);

  // get apps
  useEffect(() => {
    let _isMounted = true;
    getPaymentSource().then((data) => {
      if (_isMounted) {
        setItems(data);
      }
    });
    return () => {
      _isMounted = false;
    };
  }, []);

  if (!items) {
    return null;
  }

  // multiple
  if (multiple) {
    return <Multiselect type="multiselect" label={title} additionalComponent={MultiInput} data={items} countDisplayedIcons={1} width={'200px'} name={name} {...rest} />;
  }

  // single
  const itemsEl = getOptionsList(items);

  return (
    <Select name={name} type="select" label={title} {...rest}>
      <option value="">{t('filter.Все')}</option>
      {itemsEl}
    </Select>
  );
};

AppFilter.propTypes = {
  name: PropTypes.string,
  multiple: PropTypes.bool,
};
